module.exports = __webpack_public_path__ + "static/img/transforma-tu-aventura-3.530974a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/transforma-tu-aventura-3.jpg
// module id = 4Yxt
// module chunks = 1